import { useState } from 'react'
import { downloadRows } from '../lib/exportCore'

// "Export" on the list pages (DataTable, Documents, Crew Certificates): the rows shown right now (search + filters
// applied), the page's own columns, as Excel (.xlsx) or CSV - made in the browser (src/lib/exportCore.js), nothing stored.
// get() -> { title, rows, columns: [{ key, label }] }
export default function ExportMenu({ get, className = 'btn', style }) {
  const [open, setOpen] = useState(false)
  const [busy, setBusy] = useState(false)
  async function run(format) {
    setOpen(false); setBusy(true)
    try { const { title, rows, columns } = get(); await downloadRows({ title, rows, columns, format }) }
    catch (e) { alert('Could not export: ' + (e.message || e)) }
    finally { setBusy(false) }
  }
  const item = { display: 'block', width: '100%', textAlign: 'left', background: 'none', border: 'none', padding: '8px 14px', fontSize: 12.5, color: 'var(--text)', cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap' }
  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      <button type="button" className={className} onClick={() => setOpen(o => !o)} disabled={busy} title="Export the rows shown (filters applied)" style={{ fontSize: 11, ...style }}>{busy ? 'Exporting…' : 'Export ▾'}</button>
      {open && <>
        <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 50 }} />
        <div role="menu" style={{ position: 'absolute', right: 0, top: 'calc(100% + 4px)', zIndex: 51, background: 'var(--card, #11161e)', border: '0.5px solid var(--border)', borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,.3)', overflow: 'hidden', minWidth: 150 }}>
          <button type="button" role="menuitem" style={item} onClick={() => run('xlsx')}>Excel (.xlsx)</button>
          <button type="button" role="menuitem" style={item} onClick={() => run('csv')}>CSV</button>
        </div>
      </>}
    </span>
  )
}
